import axios from "axios";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { baseUrl } from "../../../../boot";

export const getWishlistCount = createAsyncThunk(
  "utils/wishlist-count",
  async () => {
    try {
      const response = await axios.post(
        `${baseUrl}vancouverapis/webapp/wishlist/api/v1/wishlist-count/${localStorage.getItem(
          "customerId"
        )}`
      );
      // console.log("wish list count resonse ", response);
      return response;
    } catch (error) {
      throw error;
    }
  }
);

// get wishlist products

export const getWishlistProducts = createAsyncThunk(
  "utils/wishlist-details",
  async () => {
    try {
      const response = await axios.post(
        `${baseUrl}vancouverapis/webapp/wishlist/api/v1/wishlist-details/${localStorage.getItem(
          "customerId"
        )}`
      );
      // console.log("wish list products resonse ", response);
      return response;
    } catch (error) {
      throw error;
    }
  }
);
